import { BaseMessage } from './base.js';
export class ErrorMessage extends BaseMessage {
    payload;
    constructor(payload) {
        super(payload);
        this.payload = payload;
    }
    get message() {
        return this.payload.message;
    }
}
